import {deleteDoc} from 'firebase/firestore';
import getExamModuleDocRef from './getExamModuleDocRef';

export default async function deleteExamModuleDoc(id: string): Promise<void> {
  await deleteDoc(getExamModuleDocRef(id));
}
